/** Tracks an in-progress filter/panel outside-close pointer gesture. Assumes one gesture at a time. */
let gestureActive = false;

export function beginPanelOutsideCloseGesture(): void {
  gestureActive = true;
}

export function endPanelOutsideCloseGesture(): void {
  gestureActive = false;
}

export function isPanelOutsideCloseGestureActive(): boolean {
  return gestureActive;
}

/** Backup guard for canvas handlers if document click capture is bypassed. */
export function consumeIfPanelOutsideCloseGesture(event: Event): boolean {
  if (!gestureActive) {
    return false;
  }
  event.stopPropagation();
  return true;
}
